import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { IEmployeeRoster } from '../shared/models/roster/employee-roster';

@Component({
  selector: 'pps-employee-name-renderer',
  template: `
    <i *ngIf="isBirthday()" title="Happy birthday!" class="p-mr-2 fas fa-birthday-cake fa-lg text-danger"></i>
    <span>{{employeeName}}</span>
  `
})
export class EmployeeNameRenderer implements ICellRendererAngularComp {
  employeeName!: string;
  params: any;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.employeeName = this.params.context.componentParent.getDisplayName(params);
  }

  isBirthday(): boolean{
    return this.params.context.componentParent.isBirthday(this.params);
  }

  refresh(params: ICellRendererParams) {
    return false;
  }
}